import React from 'react';
import {useTranslation} from 'react-i18next';
import ScrollContainer from 'react-indiana-drag-scroll';
import styled, {css} from 'styled-components';
import {useBrand} from '../../helpers';
import {useWindowSize} from '../../hooks/useWindowSize';
import {breakpoints, mobileMediaQuery, notWebMediaQuery} from '../../styles';

const TrendingRow = ({data, className, onItemRender}) => {
    const {width} = useWindowSize();
    const {t} = useTranslation();
    const brand = useBrand();

    const maxWidth = Math.min(width, 1440);

    let itemWidth = 674; //desktop size
    let gutter = 16;
    let margin = 40;
    let count = 3;
    if (width < breakpoints.mobile) {
        gutter = 8;
        margin = 25;
        itemWidth = width - margin * 2;
    } else if (width < breakpoints.md) {
        itemWidth = Math.max((width - margin * 2 - gutter) / 2, 453);
    } else {
        //use the remaining space
        itemWidth = (maxWidth - margin * 2 - gutter * (count - 1)) / count;
    }

    if (data.length === 3) {
        return (
            <Container className={className}>
                <Title brand={brand}>{t('dkids.trending')}</Title>
                <ScrollContainer
                    horizontal={true}
                    vertical={false}
                    className="scroll-container"
                >
                    <HStack width={count * (itemWidth + gutter) - gutter}>
                        {data.map((game, index) => {
                            return (
                                <Item width={itemWidth} key={game.id}>
                                    {onItemRender(game, index)}
                                    <Number>{index + 1}</Number>
                                </Item>
                            );
                        })}
                    </HStack>
                </ScrollContainer>
            </Container>
        );
    }
    return null;
};

const Container = styled.div`
    width: 100%;
    max-width: 1440px;
    height: 400px;
    align-self: center;
    ${notWebMediaQuery} {
        width: 100%;
    }
`;

const HStack = styled.div`
    display: flex;
    flex-direction: row;
    width: ${props => props.width}px;

    padding: 16px 40px;
    justify-content: space-between;

    ${mobileMediaQuery} {
        padding: 0px 25px;
    }
`;

const Title = styled.div`
    padding: 0px 40px;
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    text-transform: uppercase;
    margin: 16px 0px 0px 0px;

    ${mobileMediaQuery} {
        padding: 16px 25px;
    }

    ${props =>
        props.brand === 'dkids' &&
        css`
            font-family: Mont;
            font-weight: 900;
        `}
`;

const Item = styled.div`
    position: relative;
    width: ${props => props.width}px;
    height: ${props => props.width * 0.5625 + 40}px;
`;

const Number = styled.div`
    position: absolute;
    left: -14px;
    bottom: 0px;
    font-family: DKids;
    font-size: 128px;
    text-shadow: 1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white,
        -1px -1px 0 white;
    color: #1021c1;
    text-transform: uppercase;
    pointer-events: none;
`;

export default TrendingRow;
